export const financialKeys = {
  all: ['financial'] as const,
  approvalByToken: (token: string) =>
    [...financialKeys.all, 'approval', token] as const,
  withdraw: () => [...financialKeys.all, 'withdraw'] as const,
  bankAccountUpdate: () =>
    [...financialKeys.all, 'bank-account-update'] as const,
}
